export const CELL_HEIGHT = 33;

export const QUERIES = {
  smallMobile: 320,
  mediumMobile: 414,
  largeMobile: 576,
  tablet: 768,
  desktop: 992,
  largeDesktop: 1200,
  fullWidth: "100%",
};

export const PREVIEW_ID = "preview-wrapper";
